import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {SemanaServices} from '../services/semana.services';
import {devolverDiaSem, SemanaModel} from '../models/semana.model';
import {TiendaServices} from '../../CoreModule/services/tienda.services';
import {TiendaEntity} from '../../CoreModule/entities/tienda.entity';
import {EmpleadoServices} from '../../CoreModule/services/empleado.services';
import {EmpleadoModel} from '../../CoreModule/models/empleado.model';
import {ActivatedRoute} from '@angular/router';
import * as moment from 'moment';
import {EmpleadoSemanaModel} from '../models/empleado.semana.model';
import {NgxSpinnerService} from 'ngx-spinner';
import {forkJoin} from 'rxjs';
import {IndicadoresDiarios, IndicadoresServices} from '../services/indicadores.services';
import {getLoginUser, getLoginUserFull, UsuarioServices} from '../../CoreModule/services/usuario.services';
import {OnPermisos} from '../../CoreModule/interfaces/security.interface';
import {PERMISOS} from '../../variables';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';

@Component({
  selector: 'tienda-semana',
  templateUrl: '../templates/tiendas/tienda.template.html',
  styleUrls: ['../styles/tienda.styles.scss']
})
export class TiendaXSemanaComponent implements OnInit, OnPermisos {
  tienda: TiendaEntity;

  permisos: any = {
    VERMALLA: 0,
    ACTUALIZARHORARIOS: 0,
    VERMALLAPESOS: 0,
    EDITARMALLA: 0,
    EDITARMALLASBLOQUEADAS:0
  };

  collapses: any = {
    mallaPorc: true,
    horarioTienda: true,
    horarioEmple: true,
    indicadorGeneral: true,
    detalleEmpleado: true,
    indicadorDiario: true,
  };

  anoSelect: number;
  semSelect: number;

  opcSem: any[] = [];

  ventas: any[] = [];
  semana: SemanaModel;

  totalVentaTienda: number = 0;

  empleados: EmpleadoModel[] = [];
  mallaEmpleado: EmpleadoSemanaModel[] = [];
  indiTienda: Indicadores = new Indicadores();

  indiDiario: IndicadoresDiarios[] = [];

  rows: any[] = [];

  columns = [
    {name: 'Nombre'},
    {name: 'Meta'},
    {name: 'Venta'},
    {name: 'Ticket'},
    {name: 'Ticket Promedio', prop: 'Tpromedio'},
    {name: 'Articulo x Ticket', prop: 'artxtick'},
    {name: 'Ticket x Dia', prop: 'tickxdia'},
    {name: 'Venta x Dia', prop: 'ventaxdia'},
    {name: 'Cumplimiento'},
    {name: 'Estado'}
  ];

  verSemana: boolean = true;
  verEmple: boolean = false;

  user: any;

  comprobarMeta: number = 0;

  colMallasIncompletas: any[] = [];

  fechaServidor:any;

  @ViewChild('alertMallasIncompletas',{static:false})
  modalSemIncompleta:TemplateRef<any>;

  modalRef:BsModalRef;


  constructor(private ss: SemanaServices, private ts: TiendaServices, private es: EmpleadoServices, private activeRouter: ActivatedRoute, private mods:BsModalService, private spinner: NgxSpinnerService, private is: IndicadoresServices, private us: UsuarioServices) {
    for (let j = 0; j < 53; j++) {
      this.opcSem.push(j);
    }
  }

  ngComprobarPermisos() {

    this.user.rol.permisos.map(p => {
      if (p.id == PERMISOS.VERMALLAPORCENTAJE)
        this.permisos.VERMALLA = 1;

      if (p.id == PERMISOS.ACTUALIZARHORARIOEMPLEADO)
        this.permisos.ACTUALIZARHORARIOS = 1;

      if (p.id == PERMISOS.VERMALLAENPESOS)
        this.permisos.VERMALLAPESOS = 1;

      if (p.id == PERMISOS.EDITARMALLA)
        this.permisos.EDITARMALLA = 1;

      if(p.id == PERMISOS.EDITARMALLABLOQUEADA)
        this.permisos.EDITARMALLASBLOQUEADAS = 1;
    });


  }

  ngOnInit() {

    let id = +this.activeRouter.snapshot.params.id;

    let anoAnt, semAnt = undefined;

    if (this.activeRouter.snapshot.queryParams.ano)
      anoAnt = +this.activeRouter.snapshot.queryParams.ano;
    if (this.activeRouter.snapshot.queryParams.semana)
      semAnt = +this.activeRouter.snapshot.queryParams.semana;

    this.us.getUser(getLoginUser()).subscribe(d => {
      this.user = d.data.usuario;
      this.ngComprobarPermisos();
    });

    this.ss.devolverFechaServidor().subscribe((d:any) =>{

      // console.log(d.data.fechaServidor)
      if(d.data.fechaServidor != "")
        this.fechaServidor = moment(d.data.fechaServidor);
    });


    this.ts.getTienda(id).subscribe(d => {

      this.tienda = d.data.tienda;
      this.tienda.horario = JSON.parse(this.tienda.horario);


      if (anoAnt != undefined && semAnt != undefined) {
        this.anoSelect = anoAnt;
        this.semSelect = semAnt - 1;
        this.consultarSemana();
      } else {
        let fechaAct = moment();

        // let ano = moment().year();


        this.ss.devolverPrimerDia(fechaAct.year()).subscribe(d => {

          let primerDia = moment(d.data.ano.primerDia);

          // primerDia = moment(primerDia,"YYY-MM-DD");

          this.anoSelect = primerDia.year();
          this.semSelect = fechaAct.diff(primerDia, 'w');
          this.consultarSemana();
        });
      }
    });
  }



  consultarSemana() {
    this.spinner.show();

    this.ts.getTienda(this.tienda.id).subscribe(d5 => {


      if (this.tienda != undefined) {

        this.tienda.horario = d5.data.tienda.horario;
      }

      this.comprobarMeta = 0;
      this.ventas = [];
      this.mallaEmpleado = [];
      this.totalVentaTienda = 0;

      if (this.anoSelect == null) {
        alert('Seleccione un año valido');
        this.spinner.hide();
        return;
      }

      if (this.semSelect == null) {
        alert('Seleccione una semana valida');
        this.spinner.hide();
        return;
      }

      this.ss.devolverInfoTienda(`${this.anoSelect}-${+this.semSelect + 1}`, this.tienda.idDB, this.anoSelect, +this.semSelect).subscribe(d => {

        this.verSemana = true;
        this.empleados = [];
        this.rows = [];
        this.rows = [...this.rows];
        this.totalVentaTienda = 0;

        if (d.data.semana == null) {
          this.verSemana = false;
          this.semana = null;
          this.spinner.hide();
          return;
        }


        let debugTotal = 0;

        // console.log(d);

        d.data.ventas.map((c: any) => {
          debugTotal += c.cantidad;
        });


        this.semana = SemanaModel.CrearSemana(d.data.semana);


        if (this.semana.horario) {
          if (this.semana.horario.dias.length > 0) {
            let hrTienda: any [] = [];

            this.semana.horario.dias.map(d => {
              hrTienda.push({
                hi: d.horaInicio,
                hc: d.horaCierre
              });
            });
            // console.log(`tienda con horario`);
            this.tienda.horario = hrTienda;
            // console.log(this.tienda.horario);

          }
        }

        // console.log(this.semana);


        let ventas = d.data.ventas;

        // console.log(ventas);
        //
        // let demo = ventas.filter(v => v.vendedor == "348500");
        // console.log(demo)


        // console.log(`totales ventas ${ventas.length}`);


        if (d.data.ventas.length > 0) {
          for (let v of d.data.ventas) {

            // if(v.fecha == '2022-04-05T05:00:00.000Z')
            // {
            //   // console.log(v);
            // }
            this.ventas.push(v);
            if (v.tipodoc.includes('VN') || v.tipodoc.includes('VE') || v.tipodoc.includes('NCE') || v.tipodoc.includes('NCC'))
              this.totalVentaTienda -= v.cantidad;
            else
              this.totalVentaTienda += v.cantidad;
          }
        } else {
          alert('No se han podigo cargar las ventas, o no hay ventas para esta semana');
          this.spinner.hide();
        }


        let idsEmple: string[] = [];
        for (let e of d.data.ventas) {
          let found = idsEmple.find(i => i == e.vendedor);

          if (found == undefined)
            idsEmple.push(e.vendedor);
        }



        this.devolverEmpleadosSemana(ventas).then(() => {
          this.asignarVentasEmpleados(ventas);
          this.buscarMallaEmpleados().then(() => {
            this.ajustarHorarioInverso();
            // para pruebas, funcion que habilita el check de las mallas de los colaboradores segun el horario
            // this.ajustarHorarioEmple();
            this.verEmple = true;
            this.spinner.hide();
            this.calcularSemana();
            this.indiDiario = this.is.calcularIndicadoresDiarios(this.ventas, this.semana.mPorcentaje);
            console.log(this.empleados);
          });
        });


      });
    });
  }


  async devolverEmpleadosSemana(ventas: any[]) {

    if (this.semana.estado.finalizada == 1) {

      let vendId: any[] = [];

      let d: any = await this.es.devolverEmpleadosSemTienda(this.semana.semana, this.semana.tienda).toPromise();

      for (let e of d.data.devolverEmpleadosSemTienda) {
        let emple = new EmpleadoModel();
        emple.agregarDatos(e, this.semana);
        this.empleados.push(emple);
      }

      console.log(this.empleados);
      ventas.map(_v => {

        let emple = this.empleados.find(e => e.id == _v.vendedor);

        if (emple == undefined || emple == null) {
          let ids = vendId.find(vi => vi == _v.vendedor);
          if (ids == undefined || ids == null)
            vendId.push(_v.vendedor);
        }
      });

      let d2: any = await this.es.devolverEmpleados(vendId).toPromise();

      for (let e2 of d2.data.devolverEmpleados) {
        let emple = new EmpleadoModel();
        emple.agregarDatos(e2, this.semana);
        this.empleados.push(emple);
      }


    } else {
      let d: any = await this.es.devolverEmpleadoTienda(this.tienda.idDB).toPromise();

      for (let e of d.data.empleadoTienda) {
        let emple = new EmpleadoModel();
        emple.agregarDatos(e, this.semana);
        this.empleados.push(emple);
      }
    }

    this.empleados.sort((a: EmpleadoModel, b: EmpleadoModel) => {
      if (a.nombre > b.nombre)
        return 1;
      else
        return -1;
    });

  }

  asignarVentasEmpleados(ventas: any[]) {

    for (let emple of this.empleados) {
      let v = ventas.filter(_v => {
        return _v.vendedor == emple.id;
      });

      for (let _v of v) {
        emple.agregarVenta(_v);
      }
    }
  }

  async buscarMallaEmpleados() {


    if (this.semana.estado.horario == 0) {

      for (let emple of this.empleados) {
        let mallaEmple = new EmpleadoSemanaModel();
        mallaEmple.empleado = emple.id;
        mallaEmple.semana = this.semana.semana;
        mallaEmple.tienda = this.tienda.idDB;
        mallaEmple.metaTotal = 0;
        emple.mallaEmple = mallaEmple;
        if (!this.mallaEmpleado.find(me => me.id == emple.id))
          this.mallaEmpleado.push(mallaEmple);

      }
    } else {

      let consultas: any[] = [];
      for (let emple of this.empleados) {
        consultas.push(this.es.devolverSemanaEmpleadoTienda(emple.id, this.semana.semana, this.tienda.idDB));
      }

      let d: any = await forkJoin(consultas).toPromise();


      for (let es of d) {
        // ajuste para crear la semana

        if (es.data.empleadoSemanaTienda != null) {
          let empleSem = EmpleadoSemanaModel.CrearEmpleadoSemana(es.data.empleadoSemanaTienda);

          let emple = this.empleados.find(e => e.id == empleSem.empleado);
          emple.mallaEmple = empleSem;
          if (!this.mallaEmpleado.find(me => me.id == emple.id))
            this.mallaEmpleado.push(empleSem);
        }

      }

      for (let em of this.empleados) {

        if (em.mallaEmple == null) {
          let mallaEmple = new EmpleadoSemanaModel();
          mallaEmple.empleado = em.id;
          mallaEmple.semana = this.semana.semana;
          mallaEmple.tienda = this.tienda.idDB;
          mallaEmple.metaTotal = 0;
          em.mallaEmple = mallaEmple;

          if (!this.mallaEmpleado.find(me => me.id == em.id))
            this.mallaEmpleado.push(mallaEmple);

        }
      }

    }
  }


  comprobarPressDia() {
    let presDia: any[] = [0, 0, 0, 0, 0, 0, 0];
    let tot = 0;

    for (let m of this.mallaEmpleado) {
      m.meta.forEach((md, i) => {
        presDia[i] += md.metaDia;
        tot += md.metaDia;
      });
    }

    // console.log(presDia);
  }


  // funcion temporal, se debe dibujar el horario desde la malla y no desde el campo horario del empleado
  ajustarHorarioInverso() {
    this.empleados.map(e => {
      let me = this.mallaEmpleado.find(m => m.empleado == e.id);

      for (let i = 0; i < 7; i++) {
        if (me) {
          me.meta[i].horario.map((v, j) => {
            e.horario[i].horasAct[j].estado = v;

          });
          e.horario[i].esCompensado = me.meta[i].esCompensado;
        }
      }
    });
  }

  ajustarHorarioEmple() {
    for (let i = 0; i < 7; i++) {
      let hi = moment(this.tienda.horario[i].hi, 'hh:mm').hour();
      let hc = moment(this.tienda.horario[i].hc, 'hh:mm').hour();
      let mi = moment(this.tienda.horario[i].hi, 'hh:mm').minutes();
      let mc = moment(this.tienda.horario[i].hc, 'hh:mm').minutes();


      this.empleados.map(e => {
        let me = this.mallaEmpleado.find(m => m.empleado == e.id);

        for (let j = hi; j < hc; j++) {
          e.horario[i].horasAct[(j * 2)].estado = true;
          e.horario[i].horasAct[(j * 2) + 1].estado = true;

          me.meta[i].horario[(j * 2)] = true;
          me.meta[i].horario[(j * 2) + 1] = true;

          if (j == hi && mi != 0) {
            e.horario[i].horasAct[(j * 2)].estado = false;
            me.meta[i].horario[(j * 2)] = false;
          }

          if (j == (hc - 1) && mc != 0) {

            e.horario[i].horasAct[((j + 1) * 2)].estado = true;
            me.meta[i].horario[((j + 1) * 2)] = true;
          }
        };
      });
    };
  }

  validarHorarioSemana() {
    // this.empleados.map(e => {
    //   console.log(e.horario[0]);
    // });

    for (let i = 0; i < 7; i++) {
      let hi = moment(this.tienda.horario[i].hi, 'hh:mm').hour();
      let hc = moment(this.tienda.horario[i].hc, 'hh:mm').hour();
      let mi = moment(this.tienda.horario[i].hi, 'hh:mm').minutes();
      let mc = moment(this.tienda.horario[i].hc, 'hh:mm').minutes();


      for (let j = hi; j < hc; j++) {

        // comprobacion de hora inicial con media hora asignada
        if (j == hi && mi != 0) {
          let asignado = false;
          this.empleados.map(e => {
            if (e.horario[i].horasAct[(j * 2) + 1].estado) {
              asignado = true;
              return;
            }
          });
          if (!asignado) {
            alert(`No hay personal asignado para el dia ${devolverDiaSem(i)} a las ${j}:${'30'}`);
            return false;
          }
        } else {
          if (j == (hc - 1)) {
            if (mc != 0) {
              let asignado = false;

              this.empleados.map(e => {
                if (e.horario[i].horasAct[(j + 1) * 2].estado) {
                  asignado = true;
                  return;
                }
              });

              if (!asignado) {
                alert(`No hay personal asignado para el dia ${devolverDiaSem(i)} a las ${(j + 1)}:${'00'}`);
                return false;
              }
            } else {
              // en el caso de que la hora de cierre no tenga media hora
              let asignado = false;

              this.empleados.map(e => {
                if (e.horario[i].horasAct[(j * 2) + 1].estado) {
                  asignado = true;
                  return;
                }
              });

              if (!asignado) {
                alert(`No hay personal asignado para el dia ${devolverDiaSem(i)} a las ${(j)}:${'30'}`);
                return false;
              }
            }

          } else {


            let asignado = false;

            this.empleados.map(e => {

              if (e.horario[i].horasAct[(j * 2)].estado) {
                asignado = true;
                return;
              }
            });

            if (!asignado) {
              alert(`No hay personal asignado para el dia ${devolverDiaSem(i)} a las ${j}:${'00'}`);
              return false;
            }

            asignado = false;


            this.empleados.map(e => {
              if (e.horario[i].horasAct[(j * 2) + 1].estado) {
                asignado = true;
                return;
              }
            });

            if (!asignado) {
              alert(`No hay personal asignado para el dia ${devolverDiaSem(i)} a las ${j}:${'30'}`);
              return false;
            }


          }
        }


      }


      //   this.empleados.map(e => {
      //
      //     for (let j = hi; j < hc; j++) {
      //
      //
      //       if (j == hi && mi != 0) {
      //
      //         if (!e.horario[i].horasAct[(j * 2) + 1].estado) {
      //           if (valido) {
      //             alert(`No hay personal asignado para el dia ${e.horario[i].txtDia} a las ${j}:${'00'}`);
      //           }
      //           valido = false;
      //         }
      //       } else {
      //
      //         if (!e.horario[i].horasAct[(j * 2)].estado || !e.horario[i].horasAct[(j * 2) + 1].estado) {
      //           if (valido) {
      //
      //             alert(`No hay personal asignado para el dia ${e.horario[i].txtDia} a las ${j}:${(e.horario[i].horasAct[(j * 2)].estado) ? '30' : '00'}`);
      //           }
      //           valido = false;
      //         }
      //       }
      //
      //       if (j == (hc - 1) && mc != 0) {
      //
      //         if (!e.horario[i].horasAct[((j + 1) * 2)].estado) {
      //           if (valido) {
      //             alert(`No hay personal asignado para el dia ${e.horario[i].txtDia} a las ${(j + 1) / 2}:${'00'}`);
      //           }
      //           valido = false;
      //         }
      //       } else {
      //         if (!e.horario[i].horasAct[(j * 2)].estado || !e.horario[i].horasAct[(j * 2) + 1].estado) {
      //           if (valido) {
      //             alert(`No hay personal asignado para el dia ${e.horario[i].txtDia} a las ${j}:${(e.horario[i].horasAct[(j * 2)]) ? '30' : '00'}`);
      //           }
      //           valido = false;
      //         }
      //       }
      //     }
      //     ;
      //
      //   });
    }
    ;


    return true;
  }

  validarCantDiasColaboradores() {

    this.colMallasIncompletas = [];

    this.empleados.map(e => {
      let cantDias = 0;
      let cantComp = 0;
      e.horario.map(h => {
        if (h.esCompensado) {
          cantComp++;
          return;
        }

        let _hc = h.horasAct.find(hc => hc.estado == true);
        if (_hc)
          cantDias++;

      });


      if (cantDias + cantComp < 7) {

        let me = this.mallaEmpleado.find(m => m.empleado == e.id);
        if(me.obsTemp == "") {
          this.colMallasIncompletas.push({
            prog: cantDias,
            com: cantComp,
            emple: e,
            malla: me,
          });
        }
      }
    });

    if (this.colMallasIncompletas.length > 0) {
      alert('colaboradores con mallas incompletas');

      this.modalRef = this.mods.show(this.modalSemIncompleta);
      return false;
    }

    return true;
  }


  crearSemanasEmpleado() {

    if (!this.validarHorarioSemana())
      return;

    if (!this.validarCantDiasColaboradores())
      return;


    for (let i = 0; i < 7; i++) {

      this.empleados.map(e => {
        let me = this.mallaEmpleado.find(m => m.empleado == e.id);
        me.meta[i].esCompensado = e.horario[i].esCompensado;
        e.horario[i].horasAct.map((ha, j) => {
          me.meta[i].horario[j] = ha.estado;
        });

      });
    };

    this.calcularMetaxEmpleado();

    this.mallaEmpleado.map(me => {
      if(me.obsTemp != ""){
        me.observaciones.push(`${me.obsTemp} - ${getLoginUserFull().nombres} - ${moment().format('DD-MM-YYYY HH:mm')}`);
        me.obsTemp = "";
      }
    });


    this.mallaEmpleado.map(me => {
      this.es.addSemanaEmpleado(me).subscribe(d => {

      });
    });

    this.semana.estado.horario = 1;
    this.ss.actualizarEstadoSemana(this.semana.semana, this.tienda.idDB, this.semana.estado).subscribe(d => {

      alert('Horarios de los colaboradores almacenado con exito');
    });
    this.calcularSemana();
  }

  guardarDesdeModal(){
    this.modalRef.hide();
    if(this.semana.estado.horario == 0)
      this.crearSemanasEmpleado();
    else
      this.actualizarSemanaEmpleado();
  }

  cerrarModal(){
    for(let col of this.colMallasIncompletas){
      col.malla.obsTemp = "";
    }
    this.modalRef.hide();
  }

  actualizarSemanaEmpleado() {
    if (!this.validarHorarioSemana())
      return;

    if (!this.validarCantDiasColaboradores())
      return;



    this.mallasEn0();

    for (let i = 0; i < 7; i++) {

      this.empleados.map(e => {
        let me = this.mallaEmpleado.find(m => m.empleado == e.id);

        if (me) {
          me.meta[i].esCompensado = e.horario[i].esCompensado;
          e.horario[i].horasAct.map((ha, j) => {
            me.meta[i].horario[j] = ha.estado;
          });
        }

      });
    };

    this.calcularMetaxEmpleado();

    this.empleados.map(e => {
      let me = this.mallaEmpleado.find(m => m.empleado == e.id);
      if(me.obsTemp != ""){
        me.observaciones.push(`${me.obsTemp} - ${getLoginUserFull().nombres} - ${moment().format('DD-MM-YYYY HH:mm')}`);
        // me.obsTemp = "";
      }
    });


    this.mallaEmpleado.map(me => {

      if (me.id == null) {

        // console.log(` ${me.id} malla para crear no para actualizar`);
        this.es.addSemanaEmpleado(me).subscribe(d => {
          // console.log("agregado");
          // console.log(d);
          me.id = d.data.addEmpleadoSem.id;

        });
      } else {

        this.es.updateSemanaEmpleado(me).subscribe(d => {

        });
      }
    });

    this.calcularSemana();

  }

  actualizarMalla() {
    this.semana.recalcularPrecio();

    this.spinner.show();
    this.ss.guardarSemanas(this.semana, [this.tienda.idDB], this.semana.semana).subscribe(d => {

      alert(d.data.crearSemana);
      this.spinner.hide();
    });
  }

  calcularSemana() {
    if (this.semana) {
      this.comprobarMeta = 0;
      //this.semana.recalcularPrecio();
      this.indiTienda = this.is.calcularIndicadoresTienda(this.ventas, this.semana.mPorcentaje);
      // for (let i = 0; i < 7; i++) {
      //
      //   this.empleados.map(e => {
      //     let me = this.mallaEmpleado.find(m => m.empleado == e.id);
      //     console.log(e);
      //     e.horario[i].horasAct.map((ha, j) => {
      //       me.meta[i].horario[j] = ha.estado;
      //     });
      //
      //   });
      // }
      // ;

      // this.calcularMetaxEmpleado();


      this.rows = [];

      for (let e of this.empleados) {
        let malla = this.mallaEmpleado.find(me => me.empleado == e.id);


        e.calcularIndicadores(malla);
        this.comprobarMeta += e.indicadores.meta;
        //para debug
        // this.rows.push({
        //   nombre: `${e.id} - ${e.nombre} ${(malla) ? malla.id : ''}`,
        //   meta: e.indicadores.meta,
        //   venta: e.indicadores.venta,
        //   tpromedio: e.indicadores.ticketPromedio,
        //   artxtick: e.indicadores.articulosTicket,
        //   tickxdia: e.indicadores.ticketxDia,
        //   ventaxdia: e.indicadores.ventaxDia,
        //   cumplimiento: `${e.indicadores.completado}`,
        //   estado: e.indicadores.friedman
        // });

        this.rows.push({
          id: e.mallaEmple.id,
          nombre: e.nombre,
          meta: e.indicadores.meta,
          venta: e.indicadores.venta,
          ticket: e.indicadores.ticket,
          tpromedio: e.indicadores.ticketPromedio,
          artxtick: e.indicadores.articulosTicket,
          tickxdia: e.indicadores.ticketxDia,
          ventaxdia: e.indicadores.ventaxDia,
          cumplimiento: e.indicadores.completado,
          estado: e.indicadores.friedman
        });

      }


      this.rows.unshift({
        id: '',
        nombre: this.tienda.nombre,
        meta: this.indiTienda.meta,
        venta: this.indiTienda.venta,
        ticket: this.indiTienda.ticket,
        tpromedio: this.indiTienda.ticketPromedio,
        artxtick: this.indiTienda.articulosTicket,
        tickxdia: this.indiTienda.ticketxDia,
        ventaxdia: this.indiTienda.ventaxDia,
        cumplimiento: this.indiTienda.completado,
        estado: this.indiTienda.friedman
      });


      this.verSemana = true;

      this.rows = [...this.rows];
      this.comprobarPressDia();
    }
  }

  mallasEn0() {
    for (let e of this.mallaEmpleado) {
      e.meta.map(m => {
        for (let i = 0; i < m.metaHora.length; i++) {
          m.metaHora[i] = 0;
        }

        m.metaDia = 0;
      });

      e.calcularTotal();
    }

    this.calcularMetaxEmpleado();
  }

  calcularMetaxEmpleado() {

    // console.log('calculando meta empleado');


    for (let i = 0; i < 7; i++) {
      let mPor = this.semana.mPorcentaje.dias[i];


      mPor.horas.map((mh, j) => {

        let valorHora = mh.precio;

        let emples = this.mallaEmpleado.filter(e => {
          return e.meta[i].horario[j];
        });


        if (emples.length > 0) {
          valorHora = valorHora / emples.length;
          emples.map(me => {
            me.meta[i].metaHora[j] = valorHora;
          });
        }
      });

    }


    this.mallaEmpleado.map(me => {
      me.calcularTotal();
      // me.meta.map(md => {
      //   console.log(`meta dia ${md.dia} de ${md.metaDia}`);
      // });
    });


  }

  semaforoIndGeneral(indicador: any, valor) {
    let clases = [];

    switch (indicador) {
      case 1:
        if (valor < this.indiTienda.ticketPromedio)
          clases.push('semRojo');
        break;
      case 2:
        if (valor < this.indiTienda.articulosTicket)
          clases.push('semRojo');
        break;
      case 3:
        if (valor < this.indiTienda.ticketxDia)
          clases.push('semRojo');
        break;
      case 4:
        if (valor < this.indiTienda.ventaxDia)
          clases.push('semRojo');
        break;
    }

    return clases;
  }

  actualizarHorarioSemana() {


    let horarioSem: any[] = [];

    for (let h of this.semana.horario.dias) {

      horarioSem.push({
        dia: h.dia,
        horaInicio: h.horaInicio,
        horaCierre: h.horaCierre
      });


    }

    this.semana.ajustarSegunHorario();


    let jHorario = JSON.stringify(horarioSem);


    this.spinner.show();
    //query para actualizar
    this.ss.actualizarHorarioSemana(this.semana.id, jHorario).subscribe(d => {
      // console.log(d);
      this.spinner.hide();
    }, error1 => {
      this.spinner.hide();
    });
  }

}

@Component({
  selector: 'mis-tiendas',
  templateUrl: '../templates/tiendas/mis.tiendas.template.html'
})
export class MisTiendasComponent implements OnInit {

  tiendas: TiendaEntity[] = [];

  rows: any[] = [];

  columns = [
    {name: 'Nombre'},
    {name: 'Categoria'},
    {name: 'Locacion'},
    {name: 'Acciones'}
  ];

  constructor(private ts: TiendaServices, private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {
    this.spinner.show();
    this.ts.getAllTiendas().subscribe(d => {
      this.spinner.hide();

      this.tiendas = d.data.tiendas;

      this.rows = [];
      this.rows = [...this.rows];

      for (let t of this.tiendas) {
        this.rows.push({
          nombre: t.nombre,
          categoria: t.categoria,
          locacion: t.locacion,
          acciones: t.id
        });
      }

      this.rows = [...this.rows];
    });
  }

}


export class Indicadores {
  horas: number = 0;
  meta: number = 0;
  venta: number = 0;
  articulosTicket: number = 0;
  ticketPromedio: number = 0;
  ticket: number = 0;
  completado: number = 0;
  calificacion: number = 0;
  presupuesto: number = 0;
  minimo: number = 0;
  friedman: number = 0;
  cantVentas: number = 0;
  ticketxDia: number = 0;
  ventaxDia: number = 0;
  dia: string = '';

}
